// extracted by mini-css-extract-plugin
export default {"home":"index_home__ilBVx","content":"index_content__ICpup","select":"index_select__tNQMy"};